import React, { createContext, useState, useContext } from 'react';

const ProgressContext = createContext();

export const ProgressProvider = ({ children }) => {
  // Store the actual data
  const [fgItems, setFgItems] = useState([]);
  const [nestedData, setNestedData] = useState({});
  
  // Store the layout/UI state
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedLeaf, setSelectedLeaf] = useState(null);
  const [expandedKeys, setExpandedKeys] = useState(new Set());
  const [activeKey, setActiveKey] = useState(null);
  
  // REQUIRED FOR REFRESH & LOADING HINTS
  const [loading, setLoading] = useState(false);
  const [loadingOlder, setLoadingOlder] = useState(false);

  // State for card expansion (persists during navigation)
  const [expandedCards, setExpandedCards] = useState(new Set());

  // ✅ REFERENCE SAFE TOGGLE: Ensures React detects state updates instantly
  const toggleCardExpansion = (fgNumber) => {
    setExpandedCards(prev => {
      const next = new Set(prev);
      if (next.has(fgNumber)) {
        next.delete(fgNumber);
      } else {
        next.add(fgNumber);
      }
      return next; // Returns a brand new reference pointer
    });
  };

  // ✅ NEW HELPER: Allows AdminProgress to explicitly add cards without relying on toggles
  const forceExpandCard = (fgNumber) => {
    setExpandedCards(prev => {
      if (prev.has(fgNumber)) return prev; // If already open, do not force an unneeded re-render
      const next = new Set(prev);
      next.add(fgNumber);
      return next;
    });
  };

  // ✅ NEW HELPER: Clears both UI states completely when hitting "Reset" or logging out
  const clearExpandedUIStates = () => {
    setExpandedKeys(new Set());
    setExpandedCards(new Set());
  };

  return (
    <ProgressContext.Provider value={{
      fgItems, setFgItems,
      nestedData, setNestedData,
      searchQuery, setSearchQuery,
      selectedLeaf, setSelectedLeaf,
      expandedKeys, setExpandedKeys,
      activeKey, setActiveKey,
      expandedCards, setExpandedCards, // Exposed the direct setter for maximum control
      toggleCardExpansion,
      forceExpandCard,          // ✅ Safely triggers unique ID expansion on global redirection
      clearExpandedUIStates,    // ✅ Keeps your Reset routines clean and straightforward

      // MUST EXPOSE THESE TO THE PROVIDER VALUE
      loading, setLoading,
      loadingOlder, setLoadingOlder
    }}>
      {children}
    </ProgressContext.Provider>
  );
};

export const useProgress = () => useContext(ProgressContext);